module.exports = "---\nurl: \"https://petstore.swagger.io/v2/swagger.json\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: \"https://online.swagger.io/validator\""


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 935
// module chunks = 0